<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    class="bg-dark">
    <CSidebarBrand class="bg-dark d-md-down-none" :to="'/'+ fatherpath">
      <div style="width:200px !important;">
        <img 
          block
          class="w-100 h-100"
          :src="companyLogo"
        />
      </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="nav"/>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
  import { getCompanyLogo } from '../../general'
  // import { routeComponentsMap } from '../../router/routesMap'

  export default {
    name: 'Sidebar',
    props:{
      fatherpath: String
    },
    data(){ 
      return {
        companyLogo: ''
      } 
    },
    async mounted() {
      const { companyLogo } = await getCompanyLogo()
      
      this.companyLogo = companyLogo
    },
    computed: {
      show () {
        return this.$store.state.sidebarShow 
      },
      minimize () {
        return this.$store.state.sidebarMinimize 
      },
      nav () {
            let nav = {
                _name: 'CSidebarNav',
                _children: []
            }

            // const routes = this.$router.options.routes.find(r => r.path == ('/' + this.fatherpath)).children
            const routes = this.$store.state.user.data.routesAccessModel.find(r => r.path == ('/' + this.fatherpath)).children
            routes.forEach(route => {
              // console.log(route);
              
              // const component = routeComponentsMap(this.$store)[route.path]
                if (!route.children) {
                    nav._children.push({
                      _name: 'CSidebarNavItem',
                      attrs: { class: 'text-wrap' },
                      name: route.name ? route.name : '',
                      // to: '/'+this.fatherpath+'/' + (route.path === '/' ? '' : route.path)
                      icon: route.icon ? route.icon : "",
                      to: route.path
                    })
                } else {
                    nav._children.push({
                      _name: 'CSidebarNavDropdown',
                      name: route.name ? route.name : '',
                      // route: '/'+this.fatherpath+'/' + route.path,     
                      icon: route.icon ? route.icon : "",
                      route: route.path,                   
                      items: route.children.map(child => {
                        // const childComponent = routeComponentsMap(this.$store)[child.path]
                        return {
                          name: child.name ? child.name : '', 
                          // to: child.path ? '/'+this.fatherpath+'/'+route.path+'/'+child.path : ''
                          icon: child.icon ? child.icon : "",
                          to: child.path
                        } 
                      })
                    })
                }
            })

            return [nav]
      }
    }    
  }
</script>

<style>
  .c-sidebar-nav-item .c-sidebar-nav-link {
      white-space: normal !important;
  }
  .c-sidebar-nav-dropdown-items .c-sidebar-nav-link {
      padding-left: 86px !important;
  }
  .c-sidebar-nav-item .c-sidebar-nav-link .c-sidebar-nav-icon {
      margin-left: -36 !important;
  }
  /* a {
      text-decoration: none !important;
      cursor: pointer;
  } */
</style>